import React from 'react'

import RouteMarker from 'components/configured-service/Schedule/RouteMarker'
import { ServiceMarkerLayerProps } from 'components/configured-service/Schedule/types'
import WeekDayMarker from 'components/configured-service/Schedule/WeekDayMarker'
import { MARKER_TYPE } from 'components/configured-service/tabs/MapRoutingTab/components/MarkerTypeControl'

const ServiceMapMarkers = ({
  markers = [],
  mapMarkerType,
  activeMarker,
  selectedDaysMap,
  selectedRoutesMap,
  onMouseEnter,
  onMouseLeave,
  onClick,
  dimmedIds,
  iconSize,
}: ServiceMarkerLayerProps) => {
  return markers.map(item => {
    const isActive = activeMarker?.details?.id === item.id
    const isDimmed = Boolean(dimmedIds?.has(item.id))
    if (mapMarkerType === MARKER_TYPE.ROUTE) {
      return (
        <RouteMarker
          key={item.id}
          {...item}
          iconSize={iconSize}
          isActive={isActive}
          isDimmed={isDimmed}
          selectedRoutesMap={selectedRoutesMap}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      )
    }
    return (
      <WeekDayMarker
        key={item.id}
        {...item}
        iconSize={iconSize}
        isActive={isActive}
        isDimmed={isDimmed}
        selectedDaysMap={selectedDaysMap}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    )
  })
}

export default React.memo(ServiceMapMarkers)
